import { Link } from 'react-router-dom';

export function NotFoundRoute() {
  return (
    <div className="p-6">
      <h1 className="text-xl font-bold mb-2">Page not found</h1>
      <Link to="/" className="text-[var(--color-primary-500)] underline">Go home</Link>
    </div>
  );
}
